import { Component, OnInit } from '@angular/core';
import { MetaService } from '@ngx-meta/core';
import { CanonicalService } from '../../shared/services/canonical.service';
import { RACKEO_SITE } from '../../shared/rackeo-site';

@Component({
  selector: 'app-empresa-nosotros',
  templateUrl: './empresa-nosotros.component.html',
  styleUrls: ['./empresa-nosotros.component.scss']
})
export class EmpresaNosotrosComponent implements OnInit {
  readonly imgPolaroidMision = 'assets/images/rackeo/empresa/nosotros/polaroid-marca-rackeo.png';
  readonly imgPolaroidVision = 'assets/images/rackeo/empresa/nosotros/polaroid-brujula-mision.png';
  readonly imgBannerEquipo = 'assets/images/rackeo/empresa/nosotros/banner-nuestro-equipo-trabajo.png';
  readonly imgEquipo = 'assets/images/rackeo/empresa/nosotros/polaroid-equipo-soporte-247.png';

  constructor(
    private readonly meta: MetaService,
    private readonly canonical: CanonicalService
  ) {}

  ngOnInit(): void {
    this.meta.setTitle('Empresa | Nosotros | Rackeo');
    this.meta.setTag('description', 'Conoce la misión, visión y equipo de Rackeo: hosting de calidad, mejor aliado para tu presencia web y soporte por ticket, chat y teléfono.');
    this.meta.setTag('og:type', 'website');
    this.meta.setTag('og:image:type', 'image/png');
    this.meta.setTag('og:image', RACKEO_SITE.ogImageUrl);
    this.meta.setTag('og:image:width', '1200');
    this.meta.setTag('og:image:height', '1200');
    this.meta.setTag('og:image:alt', 'Empresa | Nosotros | Rackeo');
    this.meta.setTag('og:locale', RACKEO_SITE.ogLocale);
    this.canonical.set('/empresa/nosotros');
  }
}
